import gql from 'graphql-tag'

import { Message } from '@dinosband/bv-messenger-schema'
import { ClientType } from '@dinosband/bv-apollo-client'

import { _MESSAGE_DATA_PROPERTIES } from './const'

export function subscribeMessages (apollo: ClientType, chatRoomId: number[]) {
  return apollo.subscribe<{message: Message}>({
    query: gql`subscription message($chatRoomId: [Int]!) {
      message(where: { chatRoomId: $chatRoomId }) {
          ${_MESSAGE_DATA_PROPERTIES}
      }
    }`,
    variables: {
      chatRoomId,
    },
  })
}

export function subscribeMessageUpdated (apollo: ClientType, chatRoomId: number[]) {
  return apollo.subscribe<{updatedMessage: Message}>({
    query: gql`subscription updatedMessage($chatRoomId: [Int!]) {
      updatedMessage(chatRoomId: $chatRoomId) {
          ${_MESSAGE_DATA_PROPERTIES}
      }
    }`,
    variables: {
      chatRoomId,
    },
  })
}

export function subscribeMessageDeleted (apollo: ClientType, chatRoomId: number[]) {
  return apollo.subscribe<{deletedMessage: Message}>({
    query: gql`subscription deletedMessage($chatRoomId: [Int!]) {
      deletedMessage(chatRoomId: $chatRoomId) {
          ${_MESSAGE_DATA_PROPERTIES}
      }
    }`,
    variables: {
      chatRoomId,
    },
  })
}

